<i18n>
{
	"en": {
		"defaultOperationalDepartment": "Default operating department",
		"defaultEconomicalDepartment": "Default economical department"
	},
	"no":{
		"defaultOperationalDepartment": "Standard operativ avdeling",
		"defaultEconomicalDepartment": "Standard økonomisk avdeling"
	}
}
</i18n>

<template>
	<div class="details">
		<Departments :edisetup="edisetup"/>
		<Economical :edisetup="edisetup"/>
		<OrderTypesConverter :edisetup="edisetup"/>
		<ControlLevel :controlLevelDto="edisetup.controlLevelDto"/>
	</div>
</template>

<script>

import Departments from './otherOptions/Departments.vue';
import Economical from './otherOptions/Economical.vue';
import OrderTypesConverter from './otherOptions/OrderTypesConverter.vue';
import ControlLevel from '../common/ControlLevel.vue';

export default {
	name: 'OtherOptions',
	components: { Departments, Economical, OrderTypesConverter, ControlLevel },
	props: {
		messageMetadata: Object,
		edisetup: Object
	}
};
</script>

<style lang="scss" scoped>

.details{
	display: grid;
	grid-template-columns: 300px 150px 250px 100px;
	column-gap:40px;
	row-gap: 40px;
}
</style>